export default {
  baseUrl: process.env.VUE_APP_BASE_URL,
  environment: process.env.VUE_APP_ENVIRONMENT,
  ssppUrl: process.env.VUE_APP_SSPP_URL
};
